import React, { useState, useEffect } from 'react';
import { usePortfolio } from '../Context/PortfolioContext'; // Adjust the path as needed
import { useParameters } from '../Context/ParameterContext';
import performMonteCarloOptimization from './performMonteCarloOptimization/performMonteCarloOptimization'; // Adjust path as necessary
import performMonteCarloOptimization1 from './performMonteCarloOptimization1/performMonteCarloOptimization1';
import performMonteCarloOptimization2 from './performMonteCarloOptimization2/performMonteCarloOptimization2';
import performMonteCarloOptimization3 from './performMonteCarloOptimization3/performMonteCarloOptimization3';
import performMonteCarloOptimization4 from './performMonteCarloOptimization4/performMonteCarloOptimization4';
import MeanVarianceOptimization from './MeanVarianceOptimization';
import performESGBlackLittermanOptimization from './performESGBlackLitterManOptimization/performESGBlackLitterManOptimization';
import './OptimizationSettingDisplay.css';

const OptimizationSettingsDisplay = () => {
    const { portfolioData, updateOptimizationResults, updateOptimizationMethod, updateWealth } = usePortfolio();
    const { optimizationMethod, selectedAssets, covarianceMatrix, returnsArray } = portfolioData;
    // Local state for method-specific parameters
    // Define local state for `gamma` and `numSimulations` with initial values
    const [gamma, setGamma] = useState(0.5);
    const [numSimulations, setNumSimulations] = useState(1000);
    const [coefficientOfReturn, setCoefficientOfReturn] = useState(0.5);
    const [minimumESGscore, setminimumESGscore] = useState(0);
    const [returnMin, setReturnMin] = useState(0.05);
    const [alpha, setalpha] = useState(0.5);
    const [wealth, setwealth] = useState(1000000);
    const [viewstrategyConfidence, setviewStrategyConfidence] = useState(0.5);
    const [viewworkforceConfidence, setviewworkforceConfidence] = useState(0.5);
    const [marketReturns, setmarketReturns] = useState(0.5);
    const [tau, settau] = useState(0.5);

    const coefficientOfSustainability = 1 - alpha;

    // useEffect to trigger optimization based on method selection and input validity
    // Define performOptimization function within the component
    const performOptimization = () => {
        let optimalWeights = [];

        switch (optimizationMethod) {
            case 'Mean Variance Optimization':
                optimalWeights = MeanVarianceOptimization({
                    selectedAssets: selectedAssets, 
                    gamma, 
                    covarianceMatrix, 
                    returnsArray,
                });
                console.log("The calculated optimal weight is", optimalWeights);
                break;
            case 'Monte Carlo Simulation':
                optimalWeights = performMonteCarloOptimization({
                    numSimulations,
                    gamma,
                    selectedAssets,
                    covarianceMatrix,
                    returnsArray,
                });
                console.log("The calculated optimal weight is", optimalWeights);
                break;
            // Additional cases as needed
            case 'Monte Carlo Simulation Case1':
                optimalWeights = performMonteCarloOptimization1({
                    numSimulations,
                    gamma,
                    selectedAssets,
                    covarianceMatrix,
                    returnsArray,
                    ESGmin: minimumESGscore,
                });
                console.log("minimum esg score is", minimumESGscore);
                console.log("The calculated optimal weight for the case 1 is", optimalWeights);
                break;
            case 'Monte Carlo Simulation Case2':
                // Maximizing the esg score // 
                optimalWeights = performMonteCarloOptimization2({
                    numSimulations,
                    gamma,
                    selectedAssets,
                    covarianceMatrix,
                    returnsArray,
                    returnMin:  returnMin,
                })
                console.log("minimum return score is", returnMin);
                console.log("The calculated optimal weight for the case 2 is", optimalWeights);
                break;
            case 'Monte Carlo Simulation Case3':
                // Maximizing the esg score // 
                optimalWeights = performMonteCarloOptimization3({
                    numSimulations,
                    gamma,
                    selectedAssets,
                    covarianceMatrix,
                    returnsArray,
                    alpha:  alpha,
                })
                console.log("The calculated optimal weight for the case3 is", optimalWeights);
                break;

            case 'Monte Carlo Simulation Case4':
                optimalWeights = performMonteCarloOptimization4({numSimulations,
                selectedAssets,
                covarianceMatrix,
                returnsArray,
                returnMin: returnMin,
                ESGmin: minimumESGscore,
                })
                console.log("The calculate optimal ")
                break;

            case 'Black Litterman 1':
                optimalWeights = performESGBlackLittermanOptimization({
                    numSimulations,
                    selectedAssets,
                    covarianceMatrix,
                    marketReturns: marketReturns, // Market Equilibrium Returns
                    tau: tau, // Uncertainty of market equilibrium
                    ESGWorkforceView: viewworkforceConfidence, // View on assets based on ESG workforce
                    ESGStrategyView: viewstrategyConfidence, // View on assets based on ESG strategy
                    returnMin: returnMin, // Minimum acceptable return
                    ESGmin: minimumESGscore, // Minimum acceptable ESG score
                  })
                console.log("The calculate optimal ")
                break;
            default:
                console.error("Optimization method not supported or not selected:", optimizationMethod);
                return; // Early return to prevent calling updateOptimizationResults with undefined
        }

        // Update the global state with the calculated optimal weights
        updateOptimizationResults({ optimizedWeights: optimalWeights, wealth: wealth });
    };

    const handleWealth = (e) => {
        setwealth(parseFloat(e.target.value));
    }
    // Handlers for updating `gamma` and `numSimulations`
    const handleGammaChange = (e) => {
        setGamma(parseFloat(e.target.value));
    };

    const handleNumSimulationsChange = (e) => {
        setNumSimulations(parseInt(e.target.value, 10));
    };
    
    const handleCoefficientofReturn = (e) => {
        setCoefficientOfReturn(parseFloat(e.target.value));
    };

    const handleminimumESGscore = (e) => {
        setminimumESGscore(parseFloat(e.target.value));
    }

    const handlereturnMin = (e) => {
        setReturnMin(parseFloat(e.target.value));
    }

    const handlealpha = (e) => {
        setalpha(parseFloat(e.target.value));
    }

    const handleViewstrategyConfidenceChange = (e) => {
        setviewworkforceConfidence(parseFloat(e.target.value));
    }

    const handleworkforceViewConfidenceChange = (e) => {
        setviewStrategyConfidence(parseFloat(e.target.value));
    }
    const handletau = (e) => {
        settau(parseFloat(e.target.value));
    }

    const handlemarketReturns = (e) => {
        setmarketReturns(parseFloat(e.target.value));
    }
    // Determine if the optimization method is 'Black Litterman 1'
    const isBlackLitterman1 = optimizationMethod === 'Black Litterman 1';

    // Function to handle click events
    const handleOptimizationClick = () => {
        if (!isBlackLitterman1) {
            performOptimization();
        }
        // If isBlackLitterman1 is true, the button click does nothing
    };

    return (
        <div className="esg-optimization-settings">
            {/* Inputs for Mean Variance Optimization */}
            {optimizationMethod === 'Mean Variance Optimization' && (
                <label>
                    Gamma (0-1):
                    <input
                        type="number"
                        name="gamma"
                        value={gamma}
                        min="0"
                        max="1"
                        step="0.01"
                        onChange={handleGammaChange}
                    />
                </label>
            )}

            {/* Inputs for Monte Carlo Simulation */}
            {optimizationMethod === 'Monte Carlo Simulation' && (
                <>
                <label>
                    Number of Simulations:
                    <input
                        type="number"
                        name="numSimulations"
                        value={numSimulations}

                        onChange={handleNumSimulationsChange}
                    />
                </label>
                <label>
                The Wealth Input:
                <input
                    type="number"
                    name="wealth"
                    value={wealth}
                    onChange={handleWealth}
                />
                </label>
                </>
            )}
            {/* Inputs for Monte Carlo Simulation 1*/}
            {optimizationMethod === 'Monte Carlo Simulation Case1' && (
                <>
                <label>
                    Number of Simulations:
                    <input
                        type="number"
                        name="numSimulations"
                        value={numSimulations}
                        onChange={handleNumSimulationsChange}
                    />
                </label>
                <label>
                Minimum ESG score:
                <input
                    type="number"
                    name="minimumESGscore"
                    min="0"
                    max="1"
                    step="0.01"
                    value={minimumESGscore}
                    onChange={handleminimumESGscore}
                />
                </label>
                <label>
                The Wealth Input:
                <input
                    type="number"
                    name="wealth"
                    value={wealth}
                    onChange={handleWealth}
                />
                </label>
                </>
            )}
            {/* Inputs for Monte Carlo Simulation 2*/}
            {optimizationMethod === 'Monte Carlo Simulation Case2' && (
                <>
                <label>
                    Number of Simulations:
                    <input
                        type="number"
                        name="numSimulations"
                        value={numSimulations}
                        onChange={handleNumSimulationsChange}
                    />
                </label>
                <label>
                Minimum Return score (in %):
                <input
                    type="number"
                    name="minimumReturn"
                    min="0"
                    max="100"
                    step="0.01"
                    value={returnMin}
                    onChange={handlereturnMin}
                />
                </label>
                <label>
                The Wealth Input:
                <input
                    type="number"
                    name="wealth"
                    value={wealth}
                    onChange={handleWealth}
                />
                </label>
                </>
            )}
            {/* Inputs for Monte Carlo Simulation 3*/}
            {optimizationMethod === 'Monte Carlo Simulation Case3' && (
                <>
                <label>
                    Number of Simulations:
                    <input
                        type="number"
                        name="numSimulations"
                        value={numSimulations}
                        onChange={handleNumSimulationsChange}
                    />
                </label>
                <label>
                The coefficient of return (0 - 1)
                <input
                    type="number"
                    name="minimumReturn"
                    min="0"
                    max="1"
                    step="0.01"
                    value={alpha}
                    onChange={handlealpha}
                />
                </label>
                <p>The coefficient of sustaniabllity (0-1) is {coefficientOfSustainability.toFixed(2)}</p>
                <label>
                The Wealth Input:
                <input
                    type="number"
                    name="wealth"
                    value={wealth}
                    onChange={handleWealth}
                />
                </label>
                </>
            )}
            {/* Inputs for Monte Carlo Simulation 4*/}
            {optimizationMethod === 'Monte Carlo Simulation Case4' && (
                <>
                <label>
                    Number of Simulations:
                    <input
                        type="number"
                        name="numSimulations"
                        value={numSimulations}
                        onChange={handleNumSimulationsChange}
                    />
                </label>
                <label>
                Minimum Return score (in %):
                <input
                    type="number"
                    name="minimumReturn"
                    min="0"
                    step="0.01"
                    max="100"
                    value={returnMin}
                    onChange={handlereturnMin}
                />
                </label>
                <label>
                Minimum ESG score:
                <input
                    type="number"
                    name="minimumESGscore"
                    min="0"
                    step="0.01"
                    max="1"
                    value={minimumESGscore}
                    onChange={handleminimumESGscore}
                />
                </label>
                <label>
                The Wealth Input:
                <input
                    type="number"
                    name="wealth"
                    value={wealth}
                    onChange={handleWealth}
                />
                </label>
                </>
            )}


            
            
            {/* Inputs for ESG Mean Variance Optimization */}
            {optimizationMethod === 'ESG Mean Variance Optimization' && (
                <>
                    <label>
                        Coefficient of Return (0 - 1):
                        <input 
                            type="number" 
                            name="coefficientOfReturn"
                            value={coefficientOfReturn}
                            onChange={handleCoefficientofReturn}
                            min="0"
                            max="1"
                            step="0.01"
                        />
                    </label>
                    <label>
                        Gamma (0 - 1):
                        <input 
                            type="number" 
                            name="gamma"
                            value={gamma}
                            onChange={handleGammaChange}
                            min="0"
                            max="1"
                            step="0.01"
                        />
                    </label>
                <br />
                <p>Coefficient of Sustainability: {coefficientOfSustainability.toFixed(2)}</p>
            </>
            )}
            {optimizationMethod === 'Black Litterman 1' && (
                <>
                <div className="optimization-settings-container">

                        <label className="dark-mode-label">
                            Number of Simulations:
                            <input
                                className="dark-mode-input"
                                type="number"
                                name="numSimulations"
                                value={numSimulations}
                                onChange={handleNumSimulationsChange}
                                readOnly
                            />
                        </label>
                        <label className="dark-mode-label">
                            Confidence in ESG strategy view:
                            <input
                                className="dark-mode-input"
                                type="number"
                                name="viewConfidencest"
                                min="0"
                                max="1"
                                step="0.01"
                                value={viewstrategyConfidence}
                                onChange={handleViewstrategyConfidenceChange}
                                readOnly
                            />
                            
                        </label>
                        <label className="dark-mode-label">
                            Confidence in ESG workforce view:
                            <input
                                className="dark-mode-input"
                                type="number"
                                name="viewConfidencewf"
                                min="0"
                                max="1"
                                step="0.01"
                                value={viewworkforceConfidence}
                                onChange={handleworkforceViewConfidenceChange}
                                readOnly
                            />
                        </label>
                        <label className="dark-mode-label">
                            Tau of Market Equilibrium:
                            <input
                                className="dark-mode-input"
                                type="number"
                                name="viewConfidence"
                                min="0"
                                max="1"
                                step="0.01"
                                value={tau}
                                onChange={handletau}
                                readOnly
                            />
                        </label>
                        <label className="dark-mode-label">
                            Market Return:
                            <input
                                className="dark-mode-input"
                                type="number"
                                name="viewConfidence"
                                min="0"
                                max="100"
                                step="0.01"
                                value={marketReturns}
                                onChange={handlemarketReturns}
                                readOnly
                            />
                        </label>
                        <label className="dark-mode-label">
                        Minimum Return score (in %):
                        <input
                            className="dark-mode-input"
                            type="number"
                            name="minimumReturn"
                            min="0"
                            step="0.01"
                            max="100"
                            value={returnMin}
                            onChange={handlereturnMin}
                            readOnly
                        />
                        </label>
                        <label className="dark-mode-label">
                        Minimum ESG score:
                        <input
                            className="dark-mode-input"
                            type="number"
                            name="minimumESGscore"
                            min="0"
                            step="0.01"
                            max="1"
                            value={minimumESGscore}
                            onChange={handleminimumESGscore}
                            readOnly
                        />
                        </label>
                        <label className="dark-mode-label">
                        The Wealth Input:
                        <input
                            className="dark-mode-input"
                            type="number"
                            name="wealth"
                            value={wealth}
                            onChange={handleWealth}
                            readOnly
                        />
                        </label>
                        {/* Additional inputs specific to Black Litterman could be added here */}
                        
                    </div>
                </>
            ) }
                        {/* Other component content */}
            <button
                className={`Analyze_Button ${isBlackLitterman1 ? 'disabled-button' : ''}`}
                onClick={handleOptimizationClick}
                disabled={isBlackLitterman1}
            >
                Analyze
            </button>
        </div>
    );
};

export default OptimizationSettingsDisplay;